import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';

import tt from'../../../pip/library/pi-tt/pi-tt.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export interface IHistoryModuleConfiguration extends IModuleConfiguration {
  storage_key: string;
}

declare global {
  interface IWindow {
    ['HIP']: any;
  }
}

export interface ILink {
  uri: string;
  title: string;
  time: string;
}

export class HistoryModule extends ModuleConfiguration {
  configuration: IHistoryModuleConfiguration;
  private __onHashChange__windowBound: (e: Event) => void;

  initialize(configuration: IHistoryModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);
      this.__onHashChange__windowBound = this.__onHashChange__window.bind(this);
      window.addEventListener('hashchange', this.__onHashChange__windowBound);
      resolve(this.configuration);
    });
  }

  uninitialize() {
    window.removeEventListener('hashchange', this.__onHashChange__windowBound);
  }

  private __defaultConfiguration(configuration: IHistoryModuleConfiguration) {
    return tt.mergeWith(
      'clobber',
      {
        storage_key: 'ahp-history'
      },
      configuration
    ) as IHistoryModuleConfiguration;
  }

  private __onHashChange__window(event: any) {
    const link: ILink = {
      uri: this.__getRouteUri(event),
      title: this.__getRouteTitle(event),
      time: this.__getRouteTime()
    };
    const sessionStorageHistory = window.sessionStorage.getItem(this.configuration.storage_key);
    if (sessionStorageHistory != null) {
      const getSessionStorageList = JSON.parse(sessionStorageHistory);
      window.sessionStorage.setItem(this.configuration.storage_key, JSON.stringify([link, ...getSessionStorageList]));
    } else {
      window.sessionStorage.setItem(this.configuration.storage_key, JSON.stringify([link]));
    }
  }

  __getRouteUri(event: any) {
    return event.newURL;
  }

  __getRouteTitle(event: any) {
    // @todo use navigation
    const uriHash = event.currentTarget.location.hash.slice(1);

    return uriHash.indexOf('404') >= 0 ? '404 Page Not Found' : f1.word(uriHash);

    // @todo calculate name of hash
    // const urlDetails = null; // this.ahp.routing.shell.uriTable.getURIDetailsFromRoutesList(currentURLHash);
    // /**
    //  *
    //  *  Example : /home/survey/workflows/survey_builder/1/steps/general => Home Survey Workflows Survey_Builder Steps General
    //  */

    // const titleFromURL =
    //   currentURLHash.indexOf('404') < 0
    //     ? '404 Page Not Found'
    //     : currentURLHash
    //         .match(/[0-9a-z_-]+\/*/gi)
    //         .join('')
    //         .replace(/\//g, ' ');

    // const rawTitle = urlDetails && urlDetails.title ? urlDetails.title : titleFromURL;

    // return rawTitle.replace(/(^|\s)[a-z]/g, (w: string) => w.toUpperCase());
  }

  __getRouteTime() {
    const date = new Date(Date.now());
    const time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    return time;
  }
}
